/** The template import is done inside the webapp. */
function getTemplateImportURL(templateSlug: string) {
    return `${process.env.NEXT_PUBLIC_WEBAPP_URL}/app/templates/${templateSlug}/import`
}

export { getTemplateImportURL }
